import request from '@/utils/request'

// 查询企业工作室-统计信息 申报、申请数量等等
export function getTotal(ywFwjgRecid) {
  return request({
    url: '/web/qydjxx/sbsxcx/getTotal/' + ywFwjgRecid,
    method: 'get'
  })
}
